import axios from "axios";

export const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;
const creds = { withCredentials: true };

export const api = {
  getProducts: (params) => axios.get(`${API}/products`, { params }).then((r) => r.data),
  getProduct: (slug) => axios.get(`${API}/products/${slug}`).then((r) => r.data),
  getRelated: (slug) => axios.get(`${API}/products/${slug}/related`).then((r) => r.data),
  getReviews: (slug) => axios.get(`${API}/products/${slug}/reviews`).then((r) => r.data),
  postReview: (slug, body) => axios.post(`${API}/products/${slug}/reviews`, body).then((r) => r.data),
  uploadReviewPhoto: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/uploads/review-photo`, fd).then((r) => r.data);
  },
  getStats: () => axios.get(`${API}/stats`).then((r) => r.data),
  postQuiz: (body) => axios.post(`${API}/quiz`, body).then((r) => r.data),
  validateCoupon: (body) => axios.post(`${API}/coupons/validate`, body).then((r) => r.data),
  createOrder: (body) => axios.post(`${API}/orders`, body, creds).then((r) => r.data),
  getOrder: (orderId) => axios.get(`${API}/orders/${orderId}`).then((r) => r.data),
  getPaymentConfig: () => axios.get(`${API}/payments/config`).then((r) => r.data),
  createRazorpayOrder: (body) => axios.post(`${API}/payments/razorpay-order`, body).then((r) => r.data),
  verifyPayment: (body) => axios.post(`${API}/payments/verify`, body).then((r) => r.data),
  subscribe: (email) => axios.post(`${API}/newsletter`, { email }).then((r) => r.data),
  // Auth (Emergent-managed Google)
  exchangeSession: (session_id) => axios.post(`${API}/auth/session`, { session_id }, creds).then((r) => r.data),
  getMe: () => axios.get(`${API}/auth/me`, creds).then((r) => r.data),
  logout: () => axios.post(`${API}/auth/logout`, {}, creds).then((r) => r.data),
  getMyOrders: () => axios.get(`${API}/auth/orders`, creds).then((r) => r.data),
  uploadAvatar: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/users/avatar`, fd, creds).then((r) => r.data);
  },
  // Admin (owner)
  adminCheck: () => axios.get(`${API}/admin/check`, creds).then((r) => r.data),
  adminCreateProduct: (body) => axios.post(`${API}/admin/products`, body, creds).then((r) => r.data),
  adminUpdateProduct: (slug, body) => axios.put(`${API}/admin/products/${slug}`, body, creds).then((r) => r.data),
  adminDeleteProduct: (slug) => axios.delete(`${API}/admin/products/${slug}`, creds).then((r) => r.data),
  adminUploadProductImage: (slug, file, index = -1) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/admin/products/${slug}/image?index=${index}`, fd, creds).then((r) => r.data);
  },
  adminGetOrders: () => axios.get(`${API}/admin/orders`, creds).then((r) => r.data),
  adminSetOrderStatus: (orderId, stage) => axios.put(`${API}/admin/orders/${orderId}/status`, { stage }, creds).then((r) => r.data),
};

export const fileUrl = (path) => `${BASE}/api/files/${path}`;
export const avatarUrl = (picture) =>
  !picture ? null : picture.startsWith("/api/files/") ? `${BASE}${picture}` : picture;
export const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;
